import { Capacitor } from "@capacitor/core";

export type DeviceConfig = {
    apiBaseUrl: string
    firebaseCacheSizeMB: number
};

const EMPTY_DEVICE_CONFIG: DeviceConfig = {
    // NEXT_PUBLIC_API_BASE_URL lets a dev script point the app at a locally-run functions emulator
    // without editing localStorage by hand (see `npm run dev:passkeys`). Unset everywhere else, so
    // normal builds keep talking to the deployed API.
    apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL
        ?? 'https://us-central1-firetodo2.cloudfunctions.net/api',
    firebaseCacheSizeMB: Capacitor.isNativePlatform() ? 100 : 100, // Currently, we persist firestore data in native but not web mode.
};

function loadDeviceConfig(): DeviceConfig {
    if (!global.localStorage) {
        return EMPTY_DEVICE_CONFIG;
    }

    const json = global.localStorage.getItem("travelscroll-device-config");
    if (!json) {
        return EMPTY_DEVICE_CONFIG;
    }

    try {
        const deviceConfig = JSON.parse(json) as DeviceConfig;
        console.log('Loaded device-specific configuration overrides from local storage', deviceConfig);
        return deviceConfig;
    } catch (err) {
        console.warn('Failed to parse travelscroll-device-config JSON! Falling back to empty config', err);
        return EMPTY_DEVICE_CONFIG;
    }
}

export const deviceConfig = loadDeviceConfig();
